<template>
  <AccordionItem
    v-editable="blok"
    :accordion-header="blok.label"
    :is-list-numbered="isListNumbered"
    :is-simple="blok.is_simple"
    :open-on-scroll="blok.open_on_scroll"
  >
    <template #accordion-content>
      <StoryblokComponent
        v-for="childBlok in blok.blocks"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </template>
  </AccordionItem>
</template>

<script lang="ts" setup>
import type { SbAccordionItemStoryblok } from '@/types'
interface Props {
  blok: SbAccordionItemStoryblok
  isListNumbered: boolean
}
withDefaults(defineProps<Props>(), {
  isListNumbered: false,
})
</script>
